import React, { useEffect, useState } from 'react'
import { Col, Form, Row, Toast } from 'react-bootstrap';
import { IoIosArrowDown } from 'react-icons/io';
import { ErrorMessage, Field, FieldArray, } from 'formik';
import { BiTrash } from 'react-icons/bi';
import { VscDiffAdded } from 'react-icons/vsc';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { handleKeyPressNumeric, handleNumericDot } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { calculatePercentage } from '../../../CommonUtilities/CommonFunctions/CommonFunction';
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
export default function PG(props) {

  const { Formik, years, showPgData,showCourse ,showUniversities} = props;

  //  useEffect(() => {
  //   const pgList = Formik.values.pg || [];
  //   pgList?.forEach((item, index) => {
  //     const percent = calculatePercentage(
  //       item?.marksSecured,
  //       item?.totalMarks
  //     );
  //     if (item.percentage !== percent) {
  //       Formik.setFieldValue(`pg[${index}].percentage`, percent);
  //     }
  //   });
  // }, [Formik.values.pg]);

  useEffect(() => {
    if (showPgData && showPgData.length > 0) {
      showPgData.forEach((data, index) => {
        Formik.setFieldValue(`pg[${index}].univCode`, data.univ_code);
        Formik.setFieldValue(`pg[${index}].mediumId`, data.medium_id);
        Formik.setFieldValue(`pg[${index}].yearOfPass`, data.year_of_pass);
        Formik.setFieldValue(`pg[${index}].hallTicket`, data.hall_ticket);
         Formik.setFieldValue(`pg[${index}].totalMarks`, data?.total_marks);
         Formik.setFieldValue(`pg[${index}].marksSecured`, data?.marks_secured);
         Formik.setFieldValue(`pg[${index}].percentage`, calculatePercentage(data?.marks_secured, data?.total_marks  ));
                
        Formik.setFieldValue(`pg[${index}].courseCode`, data.course_code);
        GetsubData(data?.course_code, index);
        Formik.setFieldValue(`pg[${index}].subject1`, data.subject_1);
      });
    }
  }, [showPgData]);



  // ***********Subjectss Get***********//
  const [showSub, setSub] = useState({})
  const GetsubData = (courseCode, index) => {
    let Url = config.url.CONTEXT_READ_URL + "ug-pg-subjects?course_code=" + courseCode;
    CommonAxiosGet(Url).then((res) => {
      if (res?.data?.status === true) {
        let options = res?.data?.ugpgsubjects?.map((ds, i) => {
          return (
            <option key={i} value={ds.subject_code}>{ds.subject_name}</option>
          );
        });
        setSub((prevState) => ({
          ...prevState,
          [index]: options,
        }));
      }
      else {
        setSub((prevState) => ({
          ...prevState,
          [index]: [],
        }));
      }
    });
  }
  return (
    <React.Fragment>
    <div className='personal-block mb-2'>
      <div className="personal-head">
        <span> Post Graduation </span>
      </div>
      <div className="personal-row mb-3">
        <FieldArray name="pg">
          {(formikFieldArray) => {
            return formikFieldArray.form.values.pg?.map((experienceDetails, index) => {
              return (
                <div key={index}>
                  <div className="personal-row mb-3">
                    <Row className="row mb-2" id={index}>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group  >
                            <Form.Label className="input-lable mb-2">Course <font color="red">*</font></Form.Label>
                            <Field as="select" className="input-field form-control"
                              name={`pg[${index}].courseCode`} onChange={(e) => {
                                let code = e.target.value
                                GetsubData(code, index)
                                Formik.setFieldValue(`pg[${index}].subject1`, "");
                              }}>
                              <option value="">Select</option>
                              {showCourse?.filter((val) => val.course_level === 'PG')?.map((ds, i) => {
                                return (<option key={i} value={ds?.course_code}>{ds.course_name}</option>);
                              })}
                            </Field>
                            <ErrorMessage
                              name={`pg[${index}].courseCode`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group >
                            <Form.Label className="input-lable mb-2">University <font color="red">*</font></Form.Label>
                            <Field as="select" className="input-field form-control"
                              name={`pg[${index}].univCode`}>
                              <option value="">Select</option>
                              {showUniversities.map((ds, i) => {
                                return (<option key={i} value={ds.univ_code}>{ds.univ_name}</option>);
                              })}
                            </Field>
                            <ErrorMessage
                              name={`pg[${index}].univCode`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group >
                            <Form.Label className="input-lable mb-2">Subject <font color="red">*</font></Form.Label>
                            <Field as="select"
                              className="input-field form-control"
                              name={`pg[${index}].subject1`}>
                              <option value="">Select</option>
                              {showSub[index]}
                            </Field>
                            <ErrorMessage
                              name={`pg[${index}].subject1`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>
                     
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group >
                            <Form.Label className="input-lable mb-2">Year of Passing <font color="red">*</font></Form.Label>
                            <Field as="select"
                              className="input-field form-control"
                              name={`pg[${index}].yearOfPass`}>
                              <option value="">Select</option>
                              {years.map((year) => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </Field><ErrorMessage
                              name={`pg[${index}].yearOfPass`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group>
                            <Form.Label className="input-lable mb-2">Select Medium <font color="red">*</font></Form.Label>
                            <Field as="select" className="input-field form-control" name={`pg[${index}].mediumId`}>
                              <option value="">Select</option>
                              <option value="1">TELUGU</option>
                              <option value="2">URDU</option>
                              <option value="3">HINDI</option>
                              <option value="4">KANNADA</option>
                              <option value="5">ORIYA</option>
                              <option value="6">TAMIL</option>
                              <option value="7">ENGLISH</option>
                              <option value="8">SANSKRIT</option>

                            </Field>
                            <ErrorMessage
                              name={`pg[${index}].mediumId`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <Form.Group >
                          <Form.Label className="input-lable mb-2">Hall Ticket No <font color="red">*</font></Form.Label>
                          <Field
                            type="text"
                            maxLength={15}
                            name={`pg[${index}].hallTicket`}
                            className="input-field form-control"
                            placeholder="Enter Hall Ticket Number"
                          />
                          <ErrorMessage
                            name={`pg[${index}].hallTicket`}
                            component="div"
                            className="text-error"
                          />
                        </Form.Group>
                      </Col>
                       <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <Form.Group >
                          <Form.Label className="input-lable mb-2">Total Marks<font color="red">*</font></Form.Label>
                          <Field
                            type="text"
                            name={`pg[${index}].totalMarks`}
                            className="input-field form-control"
                            maxLength="4"
                              onChange={(e) => {
                                let securedMarks = Formik.values.pg[index].marksSecured;
                                let totalMarks = e.target.value;
                                if (securedMarks > totalMarks) {
                              return Sweetalert("Marks Secured cannot be greater than Total Marks",'error');
                                   }
                                let val =  calculatePercentage(securedMarks, totalMarks)
                                Formik.setFieldValue(`pg[${index}].percentage`, val);
                                handleKeyPressNumeric(e); }}    
                          />
                          <ErrorMessage
                            name={`pg[${index}].totalMarks`}
                            component="div"
                            className="text-error"
                          />
                        </Form.Group>
                      </Col>
                       <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <Form.Group >
                          <Form.Label className="input-lable mb-2">Marks Secured <font color="red">*</font></Form.Label>
                          <Field
                            type="text"
                            name={`pg[${index}].marksSecured`}
                            className="input-field form-control"
                            maxLength="4"
                              // onChange={(e) => {
                              //   let securedMarks = e.target.value;
                              //   let totalMarks = Formik.values.pg[index].totalMarks;
                              //     if (securedMarks > totalMarks) {
                              // return Sweetalert("Marks Secured cannot be greater than Total Marks",'error');
                              //      }
                              //    let val =  calculatePercentage(securedMarks, totalMarks)
                              //   Formik.setFieldValue(`pg[${index}].percentage`, val);
                              //   handleKeyPressNumeric(e); }}    
                              onChange={(e) => {
  let securedMarks = Number(e.target.value);
  let totalMarks = Number(Formik.values.pg[index].totalMarks);
  if (securedMarks > totalMarks) {
    return Sweetalert("Marks Secured cannot be greater than Total Marks", "error");
  }
  Formik.setFieldValue(`pg[${index}].marksSecured`, securedMarks);
  let val = calculatePercentage(securedMarks, totalMarks);
  Formik.setFieldValue(`pg[${index}].percentage`, val);
  handleKeyPressNumeric(e);
}}
                          />
                          <ErrorMessage
                            name={`pg[${index}].marksSecured`}
                            component="div"
                            className="text-error"
                          />
                        </Form.Group>
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <Form.Group >
                          <Form.Label className="input-lable mb-2">Percentage of marks(including languages)<font color="red">*</font></Form.Label>
                          <Field
                            type="text"
                            readOnly
                            name={`pg[${index}].percentage`}
                            className="input-field form-control"
                            maxLength="4"
                              onChange={(e) => {
                                handleKeyPressNumeric(e); }}    
                          />
                          <ErrorMessage
                            name={`pg[${index}].percentage`}
                            component="div"
                            className="text-error"
                          />
                        </Form.Group>
                      </Col>

                    </Row>
                  </div>
                  <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='mb-3' >
                      <div className='float-end'><button type="button" className="button-titile btn btn-sm btn-success mb-2 btn-end"
                        onClick={() => formikFieldArray.push({
                          univCode: "",
                          mediumId: "",
                          yearOfPass: "",
                          hallTicket: "",
                          totalMarks: "",
                          marksSecured: "",
                          percentage: "",
                          subject1: "",
                          courseCode: "",
                        })}>
                        <VscDiffAdded style={{ fontSize: "20px" }}></VscDiffAdded> PG
                      </button>
                        {(Formik.values.pg.length >= 2) ? (<>
                          &emsp;<button type="button" className="button-titile btn btn-sm btn-danger mb-2" onClick={() => formikFieldArray.remove(index)}><BiTrash style={{ fontSize: "20px" }}></BiTrash></button>
                        </>) : ("")}</div>
                    </Col>
                  </Row>
                </div>
              );
            });
          }}
        </FieldArray>
      </div>
      </div>
    </React.Fragment>
  )
}
